import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { useApi } from "../client";
import keys from "./keys";
import { Area } from "./types";

export const useArea = ({ id }: { id: string }) => {
  const api = useApi();

  return useQuery({
    queryKey: keys.one(id),
    queryFn: async (): Promise<Area> => {
      const area = await api.get(`areas/${id}`);

      return await area.json();
    },
  });
};

export const useAreaSuspense = ({ id }: { id: string }) => {
  const api = useApi();

  return useSuspenseQuery({
    queryKey: keys.one(id),
    queryFn: async (): Promise<Area> => {
      const area = await api.get(`areas/${id}`);

      return await area.json();
    },
  });
};

export const useClientAreasSuspense = () => {
  const api = useApi();

  return useSuspenseQuery({
    queryKey: keys.all(),
    queryFn: async (): Promise<Area[]> => {
      const areas = await api.get(`areas/user`);
      return areas.json();
    },
  });
};

export const useAreas = () => {
  const api = useApi();

  return useQuery({
    queryKey: keys.all(),
    queryFn: async (): Promise<Area[]> => {
      const areas = await api.get(`areas/user`);
      return await areas.json();
    },
  });
};
